<template>
    <section class="font-poppins">
        <TheHeader/>
        
        <div class="image-container relative pt-20 ">
            <img src="../Images/carrgo-team.jpg" class="images relative" alt="">
            <div  class=" centered  text-white md:text-sm md:mt-4">
                <p class="text-4xl text-center leading-10  md:text-xl sm:text-sm md:mt-20">
                    DSO Affiliates
                </p>
                <div class="flex justify-center mt-6 sm:mt-1 sm:pb-4 ">
                    <router-link to="/dso-step-one-registration" class="p-2 sm:p-0 border border-gray-100 rounded-lg font-semibold sm:text-xs">SIGN UP AS DSO</router-link>
                </div>
                
            </div>
        </div>
        <div class="flex justify-around mt-10 md:flex-col p-2 md:mt-4 pb-20 md:pb-6">
            <div class="w-1/3 mt-10 md:w-full">
                <div>
                    <p class="font-bold text-blue-600 text-xl mb-4 md:text-lg">CARRYGO DSO AFFILIATES</p>
                    <p class="leading-7">
                        DSO is our acronym for Delivery Service Operator. If you own a bike, car, 
                        van, truck or any vehicle for delivery or commuter services, joining CarryGo is the smartest move towards a profitable direction. Any other choice is a compromise. Are you enthusiastic about customer satisfaction, riders' welfare, and business growth? CarryGo will put you through. 
                        As a DSO Affiliate with CarryGo, you enjoy the following:
                    </p>
                    <div class="mt-4 font-semibold">
                        <div class="flex">
                            <div class=" w-1/2 md:w-full text-center md:bg-gray-100 md:rounded-lg md:p-2">
                                <i class="fa fa-certificate text-blue-500  p-2 bg-gray-200  rounded-lg mb-2 mt-2"></i>
                                <p class="text-sm">Government issued operational license under CarryGo </p>
                            </div>
                            <div class=" w-1/2  md:w-full text-center md:bg-gray-100 md:rounded-lg md:p-2 md:ml-1">
                                <i class="fa fa-institution text-blue-500  p-2 bg-gray-200  rounded-lg mb-2 mt-2"></i>
                                <p class="text-sm">Rider training and capacity building</p>
                            </div>
                        </div>

                        <div class="flex mt-4">
                            <div class="w-1/2 md:w-full text-center md:bg-gray-100 md:rounded-lg md:p-2">
                                <i class="fa fa-users p-2 text-blue-500  bg-gray-200  rounded-lg mb-2 mt-2"></i>
                                <p class="text-sm">Exposure to customers on massive digital space</p>
                            </div>
                            <div class=" w-1/2 md:w-full text-center md:bg-gray-100 md:rounded-lg md:p-2 md:ml-1">
                                <i class="fa fa-handshake text-blue-500  p-2 bg-gray-200  rounded-lg mb-2 mt-2"></i>
                                <p class="text-sm">Admin and training support for riders</p>
                            </div>
                        </div>
                        
                        
                        <div class=" md:w-full text-center mt-4 md:bg-gray-100 md:rounded-lg md:p-2">
                            <i class="fa fa-money text-blue-500 p-2 bg-gray-200  rounded-lg mb-2 mt-2"></i>
                            <p class="text-sm">Earn as you go</p>
                        </div>
                    </div>
                    
                </div>
                <div class="mt-8">
                    <router-link to="/dso-step-one-registration" class="p-2 border border-blue-700 text-blue-700 rounded-lg text-sm md:w-1/2 ">SIGN UP AS DSO</router-link>
                </div>
                
            </div>

            <div class="w-1/2 md:w-full md:mt-4">
                <img class="rounded-lg" src="../Images/DSOAFFILIATES.jpg" alt="">
            </div>
        </div>
        <div>
         <TheFooter/>
        </div>
    </section>
</template>

<script>
import TheHeader from '../../layout/TheHeader.vue';
import TheFooter from '../../layout/TheFooter.vue';
export default {
    components : {
        TheHeader,
        TheFooter
    }
}
</script>

<style scoped>

.images {
    width: 100%;
    opacity: 0.4;
}

.image-container {
background-color: black;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

